/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Stuck_CtaInputs */

const en_help_stuck_cta = /** @type {(inputs: Help_Stuck_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write to us`)
};

const pl_help_stuck_cta = /** @type {(inputs: Help_Stuck_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napisz do nas`)
};

/**
* | output |
* | --- |
* | "Write to us" |
*
* @param {Help_Stuck_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_stuck_cta = /** @type {((inputs?: Help_Stuck_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Stuck_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_stuck_cta(inputs)
	return en_help_stuck_cta(inputs)
});